/**
 * @param config: { imageContainerClassName: string; templateClassName: string; imageGroupClassName: string; }
 */
class VideoModalRenderer {
  constructor(config) {
    const { imageContainerClassName, imageGroupClassName, templateClassName } = config;
    this.imageContainerClassName = imageContainerClassName;
    this.imageGroupClassName = imageGroupClassName;
    this.templateClassName = templateClassName;
    this.__bindImagesClickHandler();
  }
  generateModal(iframeHTML) {
    const modal = document.createElement('hc-modal');
    const popup = document.createElement('div');
    popup.innerHTML = iframeHTML;
    popup.classList.add('popup', 'video-popup');
    modal.appendChild(popup);
    return modal;
  }
  showPopup(iframeHTML) {
    const modal = this.generateModal(iframeHTML);
    document.body.prepend(modal);
    setTimeout(() => {
      modal.classList.add('modal-open');
    });
  }
  getIframeHTMLFromClickedElement(clickedEl) {
    const templateEl = clickedEl
      .closest(`.${this.imageGroupClassName}`)
      ?.querySelector(`.${this.templateClassName}`);
    const iframeHTML = templateEl?.innerHTML;
    return iframeHTML || null;
  }
  onImageClick(event) {
    const iframeHTML = this.getIframeHTMLFromClickedElement(event.target);
    iframeHTML && this.showPopup(iframeHTML);
  }
  __bindImagesClickHandler() {
    const allImages = document.querySelectorAll(`.${this.imageContainerClassName}`);
    console.log({ allImages });
    allImages.forEach(curImage => {
      curImage.addEventListener('click', this.onImageClick.bind(this));
    });
  }
}
new VideoModalRenderer({
  imageContainerClassName: 'custom-info-with-images__single-image-box',
  imageGroupClassName: 'custom-info-with-images__image-group',
  templateClassName: 'video-iframe-template',
});
